<template>
  <div
    class="relative flex flex-col w-full h-full overflow-hidden bg-match h-2000"
  >
    <dot-grid :theme="theme" />
    <div class="z-10">
      <name-title />
      <div class="h-40 p-2 mx-8 my-16 text-3xl text-left text-white ">
        I'm working at Awardco, baby!
      </div>
      <rmr-modal
        :color="theme.colors[Math.floor(Math.random() * theme.colors.length)]"
      />
    </div>
  </div>
</template>

<script>
import DotGrid from "@/components/DotGrid/DotGrid.vue";
import NameTitle from "@/components/NameTitle/NameTitle.vue";
import rmrModal from "@/components/RMRModal.vue";

export default {
  components: {
    DotGrid,
    NameTitle,
    rmrModal,
  },
  data() {
    return {
      theme: {
        colors: [
          "#E06C75",
          "#98C379",
          "#E5C07B",
          "#61AFEF",
          "#C678DD",
          "#56B6C2",
        ],
        gray: "#424750",
      },
      showRMRModal: false,
    };
  },
  methods: {
    log(ev) {
      console.log(ev);
    },
    openRMRModal() {
      this.showRMRModal = true;
      document.body.classList.add("overflow-hidden");
    },
    closeRMRModal() {
      this.showRMRModal = false;
      document.body.classList.remove("overflow-hidden");
    },
  },
};
</script>

<style scoped>
.h-2000 {
  height: 2000px;
}
canvas.dots-canvas {
  background-color: #282c34;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.bg-match {
  background-color: #282c34;
}

.text-match {
  color: #282c34;
}
</style>
